// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ta-2";
export var chatLink = "_ta-0";
export var chatText = "_ta-1";